const TreeNodeHelper = {
  flatten(arr, childrenKeyName) {
    let newArr = [];
    for (let i = 0; i < arr.length; i++) {
      const children = arr[i][childrenKeyName];
      const pushObj = arr[i];

      if (children.length > 0) {
        newArr = newArr.concat(this.flatten(children, childrenKeyName));
        newArr.push(pushObj);
      } else {
        newArr.push(pushObj);
      }
    }
    return newArr;
  },

  flattenToTree(flattenArr, idName, childrenKeyName, parentKeyName) {
    const map = {};
    let node = undefined;
    const roots = [];
    let i;
    for (i = 0; i < flattenArr.length; i += 1) {
      map[flattenArr[i][idName]] = i; // initialize the map
      flattenArr[i][childrenKeyName] = []; // initialize the children
    }

    for (i = 0; i < flattenArr.length; i += 1) {
      node = flattenArr[i];
      if (node[parentKeyName]) {
        // if you have dangling branches check that map[node.parentId] exists

        if (
          map[node[parentKeyName]] != null ||
          map[node[parentKeyName]] != undefined
        ) {
          flattenArr[map[node[parentKeyName]]][childrenKeyName].push(node);
        }
      } else {
        roots.push(node);
      }
    }
    return roots;
  },

  findNodeInTree(element, searchKey, searchValue, childrenKey) {
    if (element[searchKey] == searchValue) {
      return element;
    } else if (element[childrenKey] != null) {
      let i;
      let result = null;
      for (i = 0; result == null && i < element[childrenKey].length; i++) {
        result = this.findNodeInTree(
          element[childrenKey][i],
          searchKey,
          searchValue,
          childrenKey
        );
      }
      return result;
    }
    return null;
  },
};

export default TreeNodeHelper;



// WEBPACK FOOTER //
// ./src/common/helper/TreeNodeHelper.js